import { useEffect, useMemo } from 'react'

import type { ChatNavigationOptions } from './useChatNavigation'
import { getRouteSyncAction, type RouteSyncActionArgs } from '../utils/routeSync'

interface UseChatRouteSyncArgs extends RouteSyncActionArgs {
  loadChatById: (selectedChatId: number, options?: ChatNavigationOptions) => void
  resetConversationState: (options?: ChatNavigationOptions) => void
}

export function useChatRouteSync({
  chatId,
  existingRouteChatId,
  isLandingRoute,
  isNewChatRoute,
  loadChatById,
  resetConversationState,
}: UseChatRouteSyncArgs) {
  const routeSyncAction = useMemo(() => getRouteSyncAction({
    chatId,
    existingRouteChatId,
    isLandingRoute,
    isNewChatRoute,
  }), [chatId, existingRouteChatId, isLandingRoute, isNewChatRoute])

  useEffect(() => {
    if (!routeSyncAction) {
      return
    }

    if (routeSyncAction.type === 'load_chat') {
      loadChatById(routeSyncAction.chatId, { shouldUpdateUrl: false })
      return
    }

    resetConversationState({ shouldUpdateUrl: false })
  }, [loadChatById, resetConversationState, routeSyncAction])
}
